import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css"; // We'll add our animation CSS here

const Login = () => {
  const [x, setx] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    if (window.localStorage.getItem("pro") !== null) {
      nav("/bill");
    }
  }, [nav]);

  const handleLogin = () => {
    if (x === "86438") {
      window.localStorage.setItem("pro", "salman");
    } else {
      window.localStorage.setItem("pro", "user");
    }
    nav("/bill");
  };

  return (
    <div className="login-container d-flex justify-content-center align-items-center vh-100">
      <div className="card login-card shadow-lg p-4 border-0">
        <h2 className="text-center mb-4 text-primary fw-bold">🔐 Login</h2>

        <input
          type="password"
          className="form-control mb-3"
          value={x}
          onChange={(e) => setx(e.target.value)}
          placeholder="Enter Password"
        />

        <button className="login-btn w-100" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;
